import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from './getOrganization';

export const maritimeDoctor = createSelector(getOrganization, function (organization): boolean {
  if (organization === undefined) return false;
  return organization.activityCodes.includes('86.21.01');
});
